import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useMemo } from "react";
import { createAppRouter } from "./routing/page-routes";
import tailwindConfig from "../tailwind.config";
import { usePraxis } from "./praxis-config/praxis-context";

export default function App() {
  const { flow } = usePraxis();
  const router = useMemo(() => createAppRouter(flow), [flow]);

  return (
    <div
      className="font-montserrat"
      style={
        {
          "--toastify-color-progress-light":
            tailwindConfig.theme.extend.colors.primary,
        } as React.CSSProperties
      }
    >
      <ToastContainer />
      <RouterProvider router={router} />
    </div>
  );
}
